// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/PaymentRefund.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────
   REFUND RECEIPT — background container
   Mirrors .invoice-container from invoice.css exactly
───────────────────────────────────────────────────────────── */
.refund-container {
  position: relative;
  width: 100%;
  max-width: 1200px;
  aspect-ratio: 8.5 / 11;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.refund-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* ─────────────────────────────────────────────────────────────
   ORIGINAL COPY  (top half)
───────────────────────────────────────────────────────────── */
.r-payment-id {
  position: absolute;
  top: 8%;
  left: 67.6%;
  font-size: 1.2vw;
  font-weight: bold;
  margin: 0;
}



.r-name {
  position: absolute;
  top: 17.3%;
  left: 11.7%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-roll-no {
  position: absolute;
  top: 22.5%;
  left: 11.7%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-branch {
  position: absolute;
  top: 22.5%;
  left: 30.2%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-college {
  position: absolute;
  top: 22.5%;
  left: 41.8%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-passout {
  position: absolute;
  top: 22.5%;
  left: 56%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-payment-date {
  position: absolute;
  top: 22.5%;
  left: 75.1%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-course {
  position: absolute;
  top: 29.5%;
  left: 11.7%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-technology {
  position: absolute;
  top: 29.5%;
  left: 41.8%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-amount {
  position: absolute;
  top: 34.9%;
  left: 13.5%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-term {
  position: absolute;
  top: 34.9%;
  left: 42%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

/* Signature — mirrors .cashier-name from invoice.css */
.r-cashier {
  position: absolute;
  top: 43%;
  left: 75%;
  font-size: 1vw;
  font-weight: bold;
  white-space: nowrap;
  overflow: visible;
  width: 22%;
  transform-origin: left center;
  margin: 0;
}

/* ─────────────────────────────────────────────────────────────
   DUPLICATE COPY  (bottom half)
───────────────────────────────────────────────────────────── */
.r-payment-id-1 {
  position: absolute;
  top: 57.6%;
  left: 67.6%;
  font-size: 1.2vw;
  font-weight: bold;
  margin: 0;
}


.r-name-1 {
  position: absolute;
  top: 67.4%;
  left: 11.7%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-roll-no-1 {
  position: absolute;
  top: 72.5%;
  left: 11.7%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-branch-1 {
  position: absolute;
  top: 72.5%;
  left: 30.2%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-college-1 {
  position: absolute;
  top: 72.5%;
  left: 41.8%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-passout-1 {
  position: absolute;
  top: 72.5%;
  left: 56%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}
.r-payment-date-1{
  position: absolute;
  top: 72.5%;
  left: 75.1%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}


.r-course-1 {
  position: absolute;
  top: 79.5%;
  left: 11.7%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-technology-1 {
  position: absolute;
  top: 79.5%;
  left: 41.8%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-amount-1 {
  position: absolute;
  top: 84.9%;
  left: 13.5%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

.r-term-1 {
  position: absolute;
  top: 84.9%;
  left: 42%;
  font-size: 1.1vw;
  font-weight: bold;
  margin: 0;
}

/* Signature — mirrors .cashier-name-1 from invoice.css */
.r-cashier-1 {
  position: absolute;
  top: 93.1%;
  left: 75%;
  font-size: 1vw;
  font-weight: bold;
  white-space: nowrap;
  overflow: visible;
  width: 22%;
  transform-origin: left center;
  margin: 0;
}

/* ─────────────────────────────────────────────────────────────
   Responsive
───────────────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .refund-container {
    max-width: 95%;
  }
  .refund-overlay h2,
  .refund-overlay h1 {
    font-size: 3vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CourseRefunds/RefundInvoice.css"],"names":[],"mappings":"AAAA;;;+DAG+D;AAC/D;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,yDAA0D;EAC1D,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;;;AAIA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,6BAA6B;EAC7B,SAAS;AACX;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;;AAGA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,6BAA6B;EAC7B,SAAS;AACX;;AAEA;;+DAE+D;AAC/D;EACE;IACE,cAAc;EAChB;EACA;;IAEE,cAAc;EAChB;AACF","sourcesContent":["/* ─────────────────────────────────────────────────────────────\r\n   REFUND RECEIPT — background container\r\n   Mirrors .invoice-container from invoice.css exactly\r\n───────────────────────────────────────────────────────────── */\r\n.refund-container {\r\n  position: relative;\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  aspect-ratio: 8.5 / 11;\r\n  background-image: url(\"../../../public/PaymentRefund.png\");\r\n  background-size: contain;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n}\r\n\r\n.refund-overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n/* ─────────────────────────────────────────────────────────────\r\n   ORIGINAL COPY  (top half)\r\n───────────────────────────────────────────────────────────── */\r\n.r-payment-id {\r\n  position: absolute;\r\n  top: 8%;\r\n  left: 67.6%;\r\n  font-size: 1.2vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n\r\n\r\n.r-name {\r\n  position: absolute;\r\n  top: 17.3%;\r\n  left: 11.7%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-roll-no {\r\n  position: absolute;\r\n  top: 22.5%;\r\n  left: 11.7%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-branch {\r\n  position: absolute;\r\n  top: 22.5%;\r\n  left: 30.2%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-college {\r\n  position: absolute;\r\n  top: 22.5%;\r\n  left: 41.8%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-passout {\r\n  position: absolute;\r\n  top: 22.5%;\r\n  left: 56%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-payment-date {\r\n  position: absolute;\r\n  top: 22.5%;\r\n  left: 75.1%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-course {\r\n  position: absolute;\r\n  top: 29.5%;\r\n  left: 11.7%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-technology {\r\n  position: absolute;\r\n  top: 29.5%;\r\n  left: 41.8%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-amount {\r\n  position: absolute;\r\n  top: 34.9%;\r\n  left: 13.5%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-term {\r\n  position: absolute;\r\n  top: 34.9%;\r\n  left: 42%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n/* Signature — mirrors .cashier-name from invoice.css */\r\n.r-cashier {\r\n  position: absolute;\r\n  top: 43%;\r\n  left: 75%;\r\n  font-size: 1vw;\r\n  font-weight: bold;\r\n  white-space: nowrap;\r\n  overflow: visible;\r\n  width: 22%;\r\n  transform-origin: left center;\r\n  margin: 0;\r\n}\r\n\r\n/* ─────────────────────────────────────────────────────────────\r\n   DUPLICATE COPY  (bottom half)\r\n───────────────────────────────────────────────────────────── */\r\n.r-payment-id-1 {\r\n  position: absolute;\r\n  top: 57.6%;\r\n  left: 67.6%;\r\n  font-size: 1.2vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n\r\n.r-name-1 {\r\n  position: absolute;\r\n  top: 67.4%;\r\n  left: 11.7%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-roll-no-1 {\r\n  position: absolute;\r\n  top: 72.5%;\r\n  left: 11.7%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-branch-1 {\r\n  position: absolute;\r\n  top: 72.5%;\r\n  left: 30.2%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-college-1 {\r\n  position: absolute;\r\n  top: 72.5%;\r\n  left: 41.8%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-passout-1 {\r\n  position: absolute;\r\n  top: 72.5%;\r\n  left: 56%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n.r-payment-date-1{\r\n  position: absolute;\r\n  top: 72.5%;\r\n  left: 75.1%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n\r\n.r-course-1 {\r\n  position: absolute;\r\n  top: 79.5%;\r\n  left: 11.7%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-technology-1 {\r\n  position: absolute;\r\n  top: 79.5%;\r\n  left: 41.8%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-amount-1 {\r\n  position: absolute;\r\n  top: 84.9%;\r\n  left: 13.5%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n.r-term-1 {\r\n  position: absolute;\r\n  top: 84.9%;\r\n  left: 42%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n  margin: 0;\r\n}\r\n\r\n/* Signature — mirrors .cashier-name-1 from invoice.css */\r\n.r-cashier-1 {\r\n  position: absolute;\r\n  top: 93.1%;\r\n  left: 75%;\r\n  font-size: 1vw;\r\n  font-weight: bold;\r\n  white-space: nowrap;\r\n  overflow: visible;\r\n  width: 22%;\r\n  transform-origin: left center;\r\n  margin: 0;\r\n}\r\n\r\n/* ─────────────────────────────────────────────────────────────\r\n   Responsive\r\n───────────────────────────────────────────────────────────── */\r\n@media (max-width: 768px) {\r\n  .refund-container {\r\n    max-width: 95%;\r\n  }\r\n  .refund-overlay h2,\r\n  .refund-overlay h1 {\r\n    font-size: 3vw;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
